import FeatureGates from '@atlaskit/feature-gate-js-client';
import { type Journey, Journeys } from '@atlassian/app-provisioning';
import { SURFACE_ANALYTICS_PRODUCT_MAP } from '@atlassian/surface-analytics';
import type { Context } from '@atlassian/surface-sdk/types';

/**
 * For Jira Background Provisioning experiment
 * https://hello.atlassian.net/wiki/spaces/RECS/pages/3778283620/Project+poster+Improve+Jira+benefits+page+and+crossflow+sign+up+flow
 *
 * This function either returns a Journey value for enrolled users
 * or undefined so the caller can fallback to a default.
 */

type GetJiraBackgroundProvisioningExperimentCohortReturnType = {
	cohort: string;
	journeyOverride?: Journey;
};

type GetJiraBackgroundProvisioningExperimentCohortType = (
	context: Context,
	targetProduct: string,
) => GetJiraBackgroundProvisioningExperimentCohortReturnType | undefined;

export const getJiraBackgroundProvisioningExperimentValues: GetJiraBackgroundProvisioningExperimentCohortType =
	(context, targetProduct) => {
		const { product } = context;

		if (
			!['jira', 'confluence', 'townsquare', 'admin'].includes(product || '') ||
			targetProduct !== SURFACE_ANALYTICS_PRODUCT_MAP.products['jira-software.ondemand']
		) {
			return;
		}

		const experimentName = 'jira_improve_benefits_page_and_cffe_signup_flow';
		const cohort: string = FeatureGates.getExperimentValue(
			experimentName,
			'cohort',
			'not-enrolled',
		);

		if (cohort !== 'not-enrolled') {
			return {
				cohort,
				journeyOverride: cohort === 'experiment' ? Journeys.GET_STARTED : Journeys.DECIDE,
			};
		}

		return {
			cohort: 'not-enrolled',
		};
	};
